import { Component, type ErrorInfo, type ReactNode } from 'react';
import { Button, Callout } from '@humanforce/mango-ui-react';

export interface ErrorBoundaryProps {
  children: ReactNode;
  title?: string;
  message?: string;
}

interface ErrorBoundaryState {
  hasError: boolean;
}

export class ErrorBoundary extends Component<ErrorBoundaryProps, ErrorBoundaryState> {
  state: ErrorBoundaryState = { hasError: false };

  static getDerivedStateFromError(): ErrorBoundaryState {
    return { hasError: true };
  }

  componentDidCatch(error: Error, errorInfo: ErrorInfo) {
    console.error('Unhandled render error caught by ErrorBoundary', error, errorInfo);
  }

  private reset = () => this.setState({ hasError: false });

  render() {
    if (this.state.hasError) {
      return (
        <Callout
          tone="critical"
          title={this.props.title ?? 'Something went wrong'}
          action={<Button label="Retry" variant="secondary" size="small" onClick={this.reset} />}
        >
          {this.props.message ?? 'This section could not be displayed. Retrying reloads it from scratch.'}
        </Callout>
      );
    }

    return this.props.children;
  }
}
